import tableCrud from '../pages/allModules/redux/tableCrud/index';

const rootReducer = {
	tableCrud,
};

export default rootReducer;
